import React, { useState, useEffect } from "react";
import {
  Stack,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableCell,
  IconButton,
} from "@mui/material";
import moment from "moment";
//Icons
import { IoAddCircleOutline } from "react-icons/io5";
//Srcs
import ListExpense from "./ListExpense";

export default function ExpenseListComp({
  setUpdateExpenseItem,
  disbursementList,
  mainItem,
  setDisbursementList,
  requiredField,
  setRequiredField,
}) {
  //============================ Start list Expense ===============================
  const handleAddExpense = (mainKey) => {
    let newdisbursementList = disbursementList;
    if (newdisbursementList?.length > 0) {
      newdisbursementList?.map((d) => {
        if (d.key === mainKey) {
          let newItems = d.items;
          newItems.push({
            mainKey: "",
            invDate: moment(),
            invNo: "",
            description: "",
            supplierId: "",
            supplierName: "",
            qty: 0,
            exchangeRate: 0,
            priceKHR: 0,
            priceUSD: 0,
            key: "list" + Date.now(),
          });
          d.items = newItems;
        }
      });
      setDisbursementList([...newdisbursementList]);
    }
  };

  //=================== List Exspense ==============
  const deleteExpensetList = (mainKey, subKey) => {
    let newdisbursementList = disbursementList;
    if (newdisbursementList?.length > 0) {
      newdisbursementList?.map((d) => {
        if (d.key === mainKey) {
          let newItems = d.items?.filter((e) => e.key !== subKey);
          d.items = newItems;
        }
      });
    }
    setDisbursementList([...newdisbursementList]);
  };

  //===============invoiceNumber=================
  const setUpdateInvoiceNumber = (mainKey, subKey, invNo) => {
    let newdisbursementList = disbursementList;
    if (newdisbursementList?.length > 0) {
      newdisbursementList?.map((d) => {
        if (d.key === mainKey) {
          let newItems = d.items;
          newItems?.map((i) => {
            if (i.key === subKey) {
              i.mainKey = mainKey;
              i.invNo = invNo;
            }
          });
          d.items = newItems;
        }
      });
    }
    setDisbursementList([...newdisbursementList]);
  };

  // console.log(disbursementList)

  //=================== Date ======================
  const setUpdateDate = (mainKey, subKey, invDate) => {
    let newdisbursementList = disbursementList;
    if (newdisbursementList?.length > 0) {
      newdisbursementList?.map((d) => {
        if (d.key === mainKey) {
          let newItems = d.items;
          newItems?.map((i) => {
            if (i.key === subKey) {
              i.mainKey = mainKey;
              i.invDate = invDate;
            }
          });
          d.items = newItems;
        }
      });
    }
    setDisbursementList([...newdisbursementList]);
    if (invDate !== "" || invDate !== undefined) {
      setRequiredField(false);
    } else {
      setRequiredField(true);
    }
  };

  //=================== Description ======================
  const setUpdateDescription = (mainKey, subKey, description) => {
    let newdisbursementList = disbursementList;
    if (newdisbursementList?.length > 0) {
      newdisbursementList?.map((d) => {
        if (d.key === mainKey) {
          let newItems = d.items;
          newItems?.map((i) => {
            if (i.key === subKey) {
              i.mainKey = mainKey;
              i.description = description;
            }
          });
          d.items = newItems;
        }
      });
    }
    setDisbursementList([...newdisbursementList]);

    if (description !== "" || description !== undefined) {
      setRequiredField(false);
    } else {
      setRequiredField(true);
    }
  };

  //===============Supplier=================
  const setUpdateSupplier = (mainKey, subKey, supplierId, supplierName) => {
    let newdisbursementList = disbursementList;
    if (newdisbursementList?.length > 0) {
      newdisbursementList?.map((d) => {
        if (d.key === mainKey) {
          let newItems = d.items;
          newItems?.map((i) => {
            if (i.key === subKey) {
              i.mainKey = mainKey;
              i.supplierId = supplierId;
              i.supplierName = supplierName;
            }
          });
          d.items = newItems;
        }
      });
    }
    setDisbursementList([...newdisbursementList]);

    if (supplierId !== "" || supplierId !== undefined) {
      setRequiredField(false);
    } else {
      setRequiredField(true);
    }
  };

  //===============quantity=================
  const setUpdateQuantity = (mainKey, subKey, qty) => {
    let newdisbursementList = disbursementList;
    if (newdisbursementList?.length > 0) {
      newdisbursementList?.map((d) => {
        if (d.key === mainKey) {
          let newItems = d.items;
          newItems?.map((i) => {
            if (i.key === subKey) {
              i.mainKey = mainKey;
              i.qty = parseInt(qty);
            }
          });
          d.items = newItems;
        }
      });
    }
    setDisbursementList([...newdisbursementList]);

    if (qty !== "" && qty !== undefined && qty !== 0) {
      setRequiredField(false);
    } else {
      setRequiredField(true);
    }
  };

  //===============Exchange rate=================
  const setUpdateExchangeRate = (mainKey, subKey, exchangeRate) => {
    let newdisbursementList = disbursementList;
    if (newdisbursementList?.length > 0) {
      newdisbursementList?.map((d) => {
        if (d.key === mainKey) {
          let newItems = d.items;
          newItems?.map((i) => {
            if (i.key === subKey) {
              i.mainKey = mainKey;
              i.exchangeRate = parseInt(exchangeRate);
            }
          });
          d.items = newItems;
        }
      });
    }
    setDisbursementList([...newdisbursementList]);

    if (exchangeRate !== "" && exchangeRate !== undefined) {
      setRequiredField(false);
    } else {
      setRequiredField(true);
    }
  };

  //===============PriceKHR=================
  const setUpdatePriceKh = (mainKey, subKey, priceKHR) => {
    let newdisbursementList = disbursementList;
    if (newdisbursementList?.length > 0) {
      newdisbursementList?.map((d) => {
        if (d.key === mainKey) {
          let newItems = d.items;
          newItems?.map((i) => {
            if (i.key === subKey) {
              i.mainKey = mainKey;
              i.priceKHR = priceKHR === "" ? 0 : parseFloat(priceKHR);
              // i.priceKHR =
              //   priceKHR < 0 || priceKHR === "" ? 0 : parseFloat(priceKHR);
            }
          });
          d.items = newItems;
        }
      });
    }
    setDisbursementList([...newdisbursementList]);

    if (priceKHR !== "" || priceKHR !== 0) {
      setRequiredField(false);
    } else {
      setRequiredField(true);
    }
  };

  //===============PriceUSD=================
  const setUpdatePriceUsd = (mainKey, subKey, priceUSD) => {
    let newdisbursementList = disbursementList;
    if (newdisbursementList?.length > 0) {
      newdisbursementList?.map((d) => {
        if (d.key === mainKey) {
          let newItems = d.items;
          newItems?.map((i) => {
            if (i.key === subKey) {
              i.mainKey = mainKey;
              // i.priceUSD =
              //   priceUSD < 0 || priceUSD === "" ? 0 : parseFloat(priceUSD);
              i.priceUSD = priceUSD === "" ? 0 : parseFloat(priceUSD);
            }
          });
          d.items = newItems;
        }
      });
    }
    setDisbursementList([...newdisbursementList]);
    if (priceUSD !== "" || priceUSD !== 0) {
      setRequiredField(false);
    } else {
      setRequiredField(true);
    }
  };

  //============================ End list Expense ===============================

  // ======================= Resize width Screen ======================
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth - 50);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);
  // ======================= End Resize width Screen ======================

  // console.log("mainItem::>", mainItem);

  return (
    <div>
      <Stack
        sx={{
          borderBottom: "1px solid #0f81c2",
          width: "100%",
        }}
        direction="row"
        justifyContent="space-between"
      >
        <Stack direction="column" justifyContent="center">
          <Typography className="field-title-sub-kh">ចំណាយ</Typography>
        </Stack>
        <IconButton onClick={() => handleAddExpense(mainItem?.key)}>
          <IoAddCircleOutline className="close-icon" />
        </IconButton>
      </Stack>

      <TableContainer sx={{ maxWidth: `${width}px` }}>
        <Table className="list-table-disbursement" aria-label="simple table">
          <TableHead className="disbursement-header-row">
            <TableCell
              className="disbursement-header-title"
              sx={{ width: "10%" }}
            >
              {/* {t("thead_invoice_number")} */}
              INV N°
            </TableCell>
            <TableCell
              className="disbursement-header-title"
              sx={{ width: "10%" }}
            >
              កាលបរិច្ឆេទ
            </TableCell>
            <TableCell
              className="disbursement-header-title"
              sx={{ width: "22%" }}
            >
              {/* {t("thead_description")} */}
              បរិយាយ
            </TableCell>
            <TableCell
              className="disbursement-header-title"
              sx={{ width: "18%" }}
            >
              {/* {t("thead_supplier")} */}
              អ្នកផ្គត់ផ្គង់
            </TableCell>
            <TableCell
              className="disbursement-header-title"
              sx={{ width: "5%" }}
            >
              {/* {t("thead_qty")} */}
              ចំនួន
            </TableCell>
            <TableCell
              className="disbursement-header-title"
              sx={{ width: "10%" }}
            >
              {/* {t("thead_unit_price_khr")} */}
              អត្រា​ប្តូ​រ​ប្រាក់
            </TableCell>
            <TableCell
              className="disbursement-header-title"
              sx={{ width: "10%" }}
            >
              {/* {t("thead_unit_price_khr")} */}
              លុយខ្មែរ
            </TableCell>
            <TableCell
              className="disbursement-header-title"
              sx={{ width: "10%" }}
            >
              {/* {t("thead_unit_price_usd")} */}
              លុយដុល្លារ
            </TableCell>
            <TableCell
              className="disbursement-header-title"
              sx={{ width: "5%" }}
            ></TableCell>
          </TableHead>

          <TableBody className="body">
            {/* {
              disbursementList?.filter(d => d?.key === mainItem?.key)
            } */}
            <ListExpense
              mainItem={mainItem}
              setDisbursementList={setDisbursementList}
              deleteExpensetList={deleteExpensetList}
              requiredField={requiredField}
              setUpdateDate={setUpdateDate}
              setUpdateDescription={setUpdateDescription}
              setUpdateSupplier={setUpdateSupplier}
              setUpdateInvoiceNumber={setUpdateInvoiceNumber}
              setUpdateQuantity={setUpdateQuantity}
              setUpdateExchangeRate={setUpdateExchangeRate}
              setUpdatePriceKh={setUpdatePriceKh}
              setUpdatePriceUsd={setUpdatePriceUsd}
            />
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
